import { FC, useCallback, useEffect, useRef, useState } from 'react';

import { Box, Stack, Tab, Tabs } from '@mui/material';

import { SearchBar } from '@/components';

import { UnitShiftListRoot } from '../styles';
import AvailableUnits from './AvailableUnits';
import { TabPanel } from './TabPanel';
import { UnitFilter } from './UnitFilter';

export const UnitShiftList: FC = () => {
  const tabsContainerRef = useRef<HTMLDivElement>(null);
  const [useScrollableTabs, setUseScrollableTabs] = useState(false);

  const TABS = [
    {
      index: 1,
      label: 'Available',
      component: AvailableUnits,
      condition: true,
    },
    {
      index: 2,
      label: 'Assigned',
      component: AvailableUnits,
      condition: true,
    },
  ];

  const visibleTabs = TABS.filter((tab) => tab.condition);

  // Function to map original index to visible index
  const getVisibleIndex = (): number => 0;

  // Function to check if tabs need scrollable variant
  const checkTabsOverflow = useCallback(() => {
    if (tabsContainerRef.current) {
      const container = tabsContainerRef.current;
      const tabsElement = container.querySelector('.MuiTabs-flexContainer');
      if (tabsElement) {
        const containerWidth = container.clientWidth;
        const tabsWidth = tabsElement.scrollWidth;
        setUseScrollableTabs(tabsWidth > containerWidth);
      }
    }
  }, []);

  // Check tabs overflow on mount and when tabs change
  useEffect(() => {
    checkTabsOverflow();
    const resizeObserver = new ResizeObserver(checkTabsOverflow);
    if (tabsContainerRef.current) {
      resizeObserver.observe(tabsContainerRef.current);
    }
    return () => resizeObserver.disconnect();
  }, [checkTabsOverflow, visibleTabs.length]);

  return (
    <UnitShiftListRoot className="unit-list" position="relative">
      <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}></Box>
      <Box sx={{ p: 1, borderBottom: 1, borderColor: 'divider' }}>
        {/* Row for Search, Filter, Refresh */}
        <Stack direction="row" spacing={1} alignItems="center">
          {' '}
          <SearchBar
            placeholder="Search Unit/Resource"
            onChange={() => {}}
            value=""
            fullWidth
          />
          <UnitFilter />
        </Stack>
      </Box>
      {/* Tabs */}
      <Tabs
        ref={tabsContainerRef}
        value={getVisibleIndex()}
        onChange={() => {}}
        variant={useScrollableTabs ? 'scrollable' : 'fullWidth'}
        scrollButtons="auto"
        sx={{ borderBottom: 1, borderColor: 'divider', overflowY: 'hidden' }}
      >
        {visibleTabs.map((tab, visibleIndex) => (
          <Tab key={visibleIndex} label={tab.label} />
        ))}
      </Tabs>

      {/* Tab Content */}
      <Box className="content" flexGrow={1} overflow="auto">
        {visibleTabs.map((tab, visibleIndex) => {
          return (
            <TabPanel
              key={tab.index}
              value={getVisibleIndex()}
              index={visibleIndex}
            >
              <tab.component />
            </TabPanel>
          );
        })}
      </Box>
    </UnitShiftListRoot>
  );
};
